





























import {Component, Prop, Vue} from 'vue-property-decorator'
import MenusStore from "@/store/modules/MenusStore";
import DialogButtons from "@/components/Dialog/parts/DialogButtons.vue";
import DialogOverlay from "@/components/Dialog/parts/DialogOverlay.vue";
import DialogTitle from "@/components/Dialog/parts/DialogTitle.vue";
import DialogWrapper from "@/components/Dialog/parts/DialogWrapper.vue";
import DialogTextField from "@/components/Dialog/parts/DialogTextField.vue";
import {Util} from "@/_global/utils";


@Component({
    components: {
        DialogTextField,
        DialogWrapper,
        DialogTitle,
        DialogButtons,
        DialogOverlay,
    },
})
export default class EditMenuDialog extends Vue {
    @Prop() private menuId!: number;

    private menuName: string = "";

    mounted() {
        const menu = MenusStore.menuById[this.menuId] || {};
        this.menuName = menu.name || "";
    }

    private onChangeName(value: string): void {
        this.menuName = value;
    }

    get editedMenu(): CMS.Menu {
        let menu: CMS.Menu = Util.deepCopy(MenusStore.menuById[this.menuId]);
        menu.name = this.menuName;
        return menu;
    }
}
